export const STATUS_OPTIONS = [
  {
    id: '4',
    title: 'PAUSE',
    icons: {
      component: 'statePause'
    }
  },
  {
    id: '1',
    title: 'DOING',
    icons: {
      component: 'stateDoing'
    }
  },
  {
    id: '2',
    title: 'NEXT',
    icons: {
      component: 'stateNext'
    }
  },
  {
    id: '0',
    title: 'DONE',
    icons: {
      component: 'stateDone'
    }
  }
];

export const RAG_OPTIONS = [
  {
    id: '2',
    title: 'RED',
    icons: {
      component: 'confidenceRed'
    }
  },
  {
    id: '1',
    title: 'AMBER',
    icons: {
      component: 'confidenceAmber'
    },
  },
  {
    id: '0',
    title: 'GREEN',
    icons: {
      component: 'confidenceGreen'
    },

  }
];

export const PRIORITY_OPTIONS = [
  {
    id: '3',
    title: 'LOW',
    icons: {
      component: 'priorityNormal'
    },
  },
  {
    id: '2',
    title: 'HIGH',
    icons: {
      component: 'priorityHigh'
    },
  },
  {
    id: '1',
    title: 'HIGHEST',
    icons: {
      component: 'priorityHighest'
    },
  }
];
